module.exports = __webpack_public_path__ + "static/img/7.1b5c1e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/7.jpg
// module id = MONf
// module chunks = 0